import React, { useContext, useEffect, useState } from "react";
import CustomList from "../Components/CustomList";
import SplitView from "../Components/SplitView";
import Pagination from "../Components/Pagination/Pagination";
import PwDetailsModal from "../Components/Modal/PwDetailsModal";
import NoteModal from "../Components/Modal/NoteModal";
import ShareModal from "../Components/Modal/ShareModal";
import MovePassword from "../Components/Modal/MovePassword";
import ConfirmModel from "../Components/Modal/ConfirmModal";
import { DataContext } from "../context/DataContext";
import { ApiCallGateway } from "../Network/apiCallGateway";
import { sweetAlert } from "../Utils/SweetAlert";
import LogsModal from "../Components/Modal/LogsModal";
function PasswordHelper(props) {
  const {
    getPasswordAccessList,
    getPasswordVault,
    handleCheckboxChange,
    setSelectedUsers,
    handleSelectUsers,
    selectedUsers,
    removeSelectUsers,
    selectedItems,
    handleSelectAll,
    setSelectedItems,
    getLogs,
    logsData,
  } = useContext(DataContext);

  const [passwordEdit, setPasswordEdit] = useState(false);
  const [noteModal, setNoteModal] = useState(false);
  const [shareModal, setShareModal] = useState(props?.shareModal);
  const [confirmModal, setConfirmModal] = useState(false);
  const [moveModal, setMoveModal] = useState(false);
  const [pwDetailsModal, setPwDetailsMoveModal] = useState(false);
  const [pwDetails, setpwDetails] = useState({});
  const [passwordId, setpasswordId] = useState("");
  const [passwordType, setPasswordType] = useState("APIs");
  const [splitItemData, setSplitItemData] = useState("");
  const [envId, setEnvId] = useState("");
  const [folderId, setFolderId] = useState("");
  const [logs, setLogs] = useState(false);

  const logsModaltoggle = () => setLogs(!logs);
  const addNotetoggle = () => setNoteModal(!noteModal);
  const sharetoggle = () => setShareModal(!shareModal);
  const confirmtoggle = () => setConfirmModal(!confirmModal);
  const movetoggle = () => setMoveModal(!moveModal);
  const pwDetailstoggle = () =>
    setPwDetailsMoveModal(!pwDetailsModal);

  useEffect(() => {
    setSelectedItems([]);
    if (
      props?.viewType === "split" &&
      props?.passwordList?.data?.length > 0
    ) {
      setSplitItemData(props?.passwordList?.data[0]);
      getPasswordAccessList(
        props?.isShared
          ? props?.passwordList?.data[0].passwordId
          : props?.passwordList?.data[0]._id,
        props?.passwordList?.data[0].envId,
        props?.passwordList?.data[0].folderId
      );
    } else {
      setSplitItemData({});
    }
  }, [props?.viewType]);

  const deletepaswword = async (passwordId) => {
    const res = await ApiCallGateway.password.deletePassword(
      passwordId
    );
    if (res?.status === 200) {
      confirmtoggle();
      props?.onRefetch();
    }
  };
  const checkPermission = (
    owner,
    edit,
    permissionType,
    expiryDate
  ) => {
    let q = new Date();
    let m = q.getMonth();
    let d = q.getDate();
    let y = q.getFullYear();

    let today = new Date(y, m, d);

    let mydate = new Date(expiryDate);

    if (!expiryDate) {
      return owner === 1 || edit === 1 || permissionType === "Edit";
    }

    if (today <= mydate) {
      return owner === 1 || edit === 1 || permissionType === "Edit";
    }
    if (today > mydate) {
      return false;
    }
    // return owner === 1 || edit === 1 || permissionType === "Edit";
  };

  const passwordLogs = (id) => {
    return;
  };
  return (
    <div>
      <div
        style={{ display: "flex", marginTop: 15, marginBottom: 15 }}
      >
        <CustomList
          selectAll={() => handleSelectAll(props?.passwordList?.data)}
          allSelected={
            selectedItems.length === props?.passwordList?.data?.length
          }
          selectedItems={selectedItems}
          selectCheckBox={(id) => handleCheckboxChange(id)}
          data={props?.passwordList?.data}
          pwDetailstoggle={(details) => {
            pwDetailstoggle();
            setpwDetails(details);
          }}
          addNotetoggle={(id) => {
            addNotetoggle();
            setpasswordId(id);
          }}
          sharetoggle={(item) => {
            // console.log(item);
            const p = checkPermission(
              item?.isOwner,
              item?.isEdit,
              item?.permissionType,
              item?.expiryDate
            );
            if (p) {
              setSelectedUsers([]);
              sharetoggle();
              getPasswordAccessList(
                props?.isShared ? item?.passwordId : item._id,
                item.envId,
                item.folderId
              );
              setpasswordId(item?.id);
              setEnvId(item?.envId);
              setFolderId(item?.folderId);
              props?.sharePasswordFormik.setFieldValue(
                "passwordId",
                props?.isShared ? item?.passwordId : item._id
              );
            } else {
              sweetAlert(
                "Oops!",
                "You do not currently have the necessary access to perform this action.",
                "warning"
              );
            }
          }}
          confirmtoggle={(item) => {
            const p = checkPermission(
              item?.isOwner,
              item?.isEdit,
              item?.permissionType,
              item?.expiryDate
            );
            if (p) {
              confirmtoggle();
              setpasswordId(item._id);
            } else {
              sweetAlert(
                "Oops!",
                "You do not currently have the necessary access to perform this action.",
                "warning"
              );
            }
          }}
          allLogs={(item) => {
            passwordLogs(item._id);
            getLogs(
              props?.isShared ? item?.passwordId : item._id,
              "",
              1,
              ""
            );
            logsModaltoggle();
          }}
          movetoggle={() => movetoggle()}
          edittoggle={(item) => {
            const p = checkPermission(
              item?.isOwner,
              item?.isEdit,
              item?.permissionType,
              item?.expiryDate
            );
            if (p) {
              props?.passweordDetails(item);
              props?.passwordModeltoggle();
              props?.setEditPassword();
            } else {
              sweetAlert(
                "Oops!",
                "You do not currently have the necessary access to perform this action.",
                "warning"
              );
            }
          }}
          splitView={props?.viewType === "split" ? true : false}
          splitItemId={splitItemData?._id}
          setSplitData={(item) => {
            setSplitItemData(item);
            getPasswordAccessList(
              props?.isShared ? item?.passwordId : item._id,
              item.envId,
              item.folderId
            );
          }}
          onCopypassword={(id) => getPasswordVault(id)}
        />
        {props?.viewType === "split" &&
        props?.passwordList?.data?.length > 0 ? (
          <div className="split-view-box">
            <SplitView
              data={splitItemData}
              sharetoggle={(item) => {
                const p = checkPermission(
                  item?.isOwner,
                  item?.isEdit,
                  item?.permissionType,
                  item?.expiryDate
                );
                if (p) {
                  setSelectedUsers([]);
                  sharetoggle();
                  getPasswordAccessList(
                    props?.isShared ? item?.passwordId : item._id,
                    item.envId,
                    item.folderId
                  );
                  props?.sharePasswordFormik.setFieldValue(
                    "passwordId",
                    props?.isShared ? item?.passwordId : item._id
                  );
                  setpasswordId(item?.id);
                  setEnvId(item?.envId);
                  setFolderId(item?.folderId);
                } else {
                  sweetAlert(
                    "Oops!",
                    "You don't have permission to share",
                    "warning"
                  );
                }
              }}
              onCopypassword={(id) => getPasswordVault(id)}
              confirmtoggle={(item) => {
                const p = checkPermission(
                  item?.isOwner,
                  item?.isEdit,
                  item?.permissionType,
                  item?.expiryDate
                );
                if (p) {
                  confirmtoggle();
                  setpasswordId(item._id);
                } else {
                  sweetAlert(
                    "Oops!",
                    "You do not currently have the necessary access to perform this action.",
                    "warning"
                  );
                }
              }}
              allLogs={(item) => {
                passwordLogs(item._id);
                getLogs(
                  props?.isShared ? item?.passwordId : item._id,
                  "",
                  ""
                );
                logsModaltoggle();
              }}
              edittoggle={(item) => {
                const p = checkPermission(
                  item?.isOwner,
                  item?.isEdit,
                  item?.permissionType,
                  item?.expiryDate
                );
                if (p) {
                  props?.passweordDetails(item);
                  props?.passwordModeltoggle();
                  props?.setEditPassword();
                } else {
                  sweetAlert(
                    "Oops!",
                    "You do not currently have the necessary access to perform this action.",
                    "warning"
                  );
                }
              }}
            />
          </div>
        ) : null}
      </div>
      <PwDetailsModal
        pwDetailsModal={pwDetailsModal}
        pwDetailsModaltoggle={pwDetailstoggle}
        details={pwDetails}
      />
      <NoteModal
        noteModal={noteModal}
        noteModaltoggle={addNotetoggle}
      />
      <ShareModal
        isPassword={true}
        shareModal={shareModal}
        shareModaltoggle={sharetoggle}
        formik={props?.sharePasswordFormik}
        handleSelectUsers={(id) => handleSelectUsers(id)}
        removeSelectUsers={(id) => removeSelectUsers(id)}
        selectedUsers={selectedUsers}
        refetchAccessList={() =>
          getPasswordAccessList(passwordId, envId, folderId)
        }
      />
      <ConfirmModel
        confirmModal={confirmModal}
        confirmModaltoggle={confirmtoggle}
        passwordId={passwordId}
        onProceed={(id) => deletepaswword(id)}
      />
      <LogsModal
        logsModal={logs}
        logsModaltoggle={logsModaltoggle}
        logs={logsData}
        logsPage={(dataId, n) => {
          getLogs(dataId, "", n, "");
        }}
      />
      <MovePassword
        moveModal={moveModal}
        moveModaltoggle={movetoggle}
      />
    </div>
  );
}

export default PasswordHelper;
